import styled from 'styled-components';
import { color } from '../../assets/styles/colors';

export const Container = styled.div`
	width: 100%;
	height: 70px;
	position: fixed;
	bottom: 0;
	left: 0;
	display: flex;
	justify-content: space-around;
	align-items: center;
	background-color: transparent;
	a {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 0 5px;
		color: ${color.grayMedium};
		font-size: 9px;

		svg {
			font-size: 30px;
		}
	}
`;
